import { render, staticRenderFns } from "./TextGrid.vue?vue&type=template&id=7c971741&scoped=true&"
import script from "./TextGrid.vue?vue&type=script&lang=js&"
export * from "./TextGrid.vue?vue&type=script&lang=js&"
import style0 from "./TextGrid.vue?vue&type=style&index=0&id=7c971741&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c971741",
  null
  
)

export default component.exports